// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"c1dc5ce3","488":"ea1387b7","796":"2b613fed"}[chunkId] + ".chunk.js";
};